<template xmlns:v-on="http://www.w3.org/1999/xhtml">
  <div 
    id="animate" 
    class="modal-dialog">
    <div class="modal-content">
      <div 
        class="modal-header" 
        style="padding: 0px;">
        <a 
          data-dismiss="modal" 
          class="pull-right text-muted text-lg p-a-sm m-r-sm">×</a>
        <div class="p-a">
          <span class="h5 text-capitalize">{{ title }}</span>
        </div>
      </div>
      <div class="modal-body text-center p-lg">
        <multiselect
          id="ajaxProduct"
          v-model="tag.products"
          :options="items"
          :multiple="true"
          :loading="ajaxProductLoading"
          :close-on-select="false"
          :clear-on-select="true"
          :hide-selected="true"
          :allow-empty="true"
          label="name"
          track-by="id"
          placeholder="Type to search"
          @search-change="loadProducts"
          @select="onSelect"
        >
          <template 
            slot="selection" 
            slot-scope="{ values, search, isOpen }">
            <span 
              v-if="values.length &amp;&amp; !isOpen" 
              class="multiselect__single">{{ values.length }} products selected</span>
          </template>
        </multiselect>

        <div class="table-wrapper-scroll-y my-custom-scrollbar m-t-1">
          <div>
            <table class="table">
              <tbody>
                <tr 
                  v-for="product in tag.products" 
                  :key="product.id">
                  <td style="text-align:left;">{{ product.name }}</td>
                  <td class="text-right">
                    <a class="nav-link text-muted m-r-sm">
                      <i
                        class="material-icons md-18"
                        @click="deleteItem(product)">&#xe14c;</i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button 
          type="button" 
          class="btn primary p-x-md" 
          data-dismiss="modal" 
          @click="apply_product()">Apply</button>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
</template>

<script>
import ProductMixin from '@js/mixins/products';
import reject from 'lodash/reject';

export default {
    props: {
        tag: {
            type: Object,
            required: true,
        },

        title: {
            type: String,
            required: false,
            default: 'Select products',
        },
    },

    data() {
        return {
            ajaxTagLoading: false,
            multiselect_query_limit: 30,
            ajaxProductLoading: false,
            api_item_select: Laroute.route('franchise.vue.products'),
            items: [],
            product: [],
            tags: [],
            loading: false,
        };
    },

    mounted() {
        var that = this;
        this.loadProducts(null);

        $('#product-popup').on('hidden.bs.modal', function(e) {
            that.errors.clear();
        });
    },

    methods: {
        onSelect(items) {
            this.tag.products = items;
        },

        apply_product() {
            this.$emit('updateProduct', this.tag.products);
        },

        deleteItem(option) {
            this.tag.products = reject(this.tag.products, option);
        },

        loadProducts: _.debounce(function(query) {
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.ajaxProductLoading = true;
            this.$http.get(this.api_item_select, options).then(response => {
                this.items = response.data.data;
                this.ajaxProductLoading = false;
            });
        }, 500),
    },
};
</script>


<style>
.my-custom-scrollbar {
    position: relative;
    height: 200px;
    overflow: overlay;
}
.table-wrapper-scroll-y {
    display: block;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tag/product_list.vue